import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseResponse } from '@ibc-shared/model/base-response.model';
import { Observable, take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConfirmResetPasswordModel, CurrentUser, LoginResponse } from '../models/auth.model';

@Injectable({
  providedIn: 'root',
})
export class AuthRepository {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/api/auth`;

  public login(email: string, password: string): Observable<BaseResponse<LoginResponse>> {
    return this.http
      .post<BaseResponse<LoginResponse>>(
        `${this.baseUrl}/login`,
        {
          email,
          password,
        },
        { withCredentials: true }
      )
      .pipe(take(1));
  }

  public check(): Observable<BaseResponse<LoginResponse>> {
    return this.http.get<BaseResponse<LoginResponse>>(`${this.baseUrl}/check-auth`, { withCredentials: true }).pipe(take(1));
  }

  public getCurrentUser(): Observable<BaseResponse<CurrentUser>> {
    return this.http.get<BaseResponse<CurrentUser>>(`${this.baseUrl}/me`, { withCredentials: true }).pipe(take(1));
  }

  public logout(): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/logout`, {}, { withCredentials: true }).pipe(take(1));
  }

  public sendResetPassword(email: string): Observable<BaseResponse<string>> {
    return this.http
      .post<BaseResponse<string>>(`${this.baseUrl}/reset-password`, {
        email: email,
      })
      .pipe(take(1));
  }

  public confirmResetPassword(data: ConfirmResetPasswordModel): Observable<BaseResponse<ConfirmResetPasswordModel>> {
    return this.http.post<BaseResponse<ConfirmResetPasswordModel>>(`${this.baseUrl}/validate-reset`, data).pipe(take(1));
  }
}
